export function isAdmin(user) {
  return user.roles.filter((role) => role.name === "Admin").length > 0;
}